/**
 * Cash movements layout guard — Layer 3 of the module gate (ADR-0046).
 *
 * Cash movements are part of the 1.0-withheld `cash` module (returns in 1.2).
 * This layout route redirects a typed `/cash-movements` URL and any nested child
 * to `/` unless the workspace is entitled to `cash`, which no 1.0 plan grants.
 * Renders only an `<Outlet/>`. @see docs/adr/0046-withheld-1.0-modules.md
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireModule } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/cash/movements")({
  beforeLoad: requireModule("cash"),
  component: Outlet,
});
